export default __webpack_public_path__ + "static/media/o-b.546ef983.png";